import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import Menu from "./Components/Menu/Menu";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Menu />
      <App />
    </Router>
  </React.StrictMode>
);

reportWebVitals();
